import { Flex, Text, Chat } from "@fluentui/react-northstar";
import ReactMarkdown from "react-markdown";

const Message = ({ message, isQuestion = false }) => {
    if (!message) {
        return null;
    }
    return (
        <Flex
            column
            gap="gap.smaller"
            styles={{
                alignItems: isQuestion ? "flex-end" : "flex-start",
                marginBottom: "12px",
            }}
        >
            <Chat.Message
                content={<ReactMarkdown>{message}</ReactMarkdown>}
                mine={isQuestion}
                styles={{
                    maxWidth: "90%",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    "&.ui-chat__message": {
                        width: isQuestion ? "fit-content" : "100%",
                    },
                }}
            />
        </Flex>
    );
};

export default Message;
